import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { BASE_MODULES, SHARED_IMPORTS } from 'src/app/constants/shared-imports';
import { CommonService } from 'src/Services/common.service';
import { AnalyticsService } from 'src/Services/gtag.service';

@Component({
  standalone: true,
  selector: 'app-ai-chat-loader',
  templateUrl: './ai-chat-loader.component.html',
  styleUrls: ['./ai-chat-loader.component.scss'],
  imports:[...BASE_MODULES, SHARED_IMPORTS.ngbTooltip]
})
export class AIChatLoaderComponent implements OnInit{
  unreadGif: boolean = false;
  userLoggedIn = 'false';
  constructor(private route: Router, protected commonService: CommonService, private analyticsService: AnalyticsService){

  }
  ngOnInit(){}


  openAiChatWindow(){
    this.commonService.trackNavigationStart = false;
    this.analyticsService.event('Ai Module' + '-' + this.commonService.getstorePageName(), {
      'event_category': 'Ai Help',
      'event_label': 'Ai Module Section opened',
      'value': 1,
      'bot_id': this.commonService.getstorePageName()
    });
    this.route.navigateByUrl('/aiHelp/aiLanding');
    parent.postMessage('AiExpand','*');

  }

  closeFlora() {
    parent.postMessage('AiBotclose','*');
  }
}
